import React, { PureComponent } from "react";
import Request from "@/networkReq/request";
import Http from "@/networkReq/http";
import { getToken, getCurrentUser,getCitys } from "utils/storage";
import {message} from 'antd'
//根据html标签 转换在div标签
export function showhtml(htmlString) {
  var html = { __html: htmlString };
  return <div className="details_cont_text" dangerouslySetInnerHTML={html}></div>;
}

// 获取时间转换
export function getDate(date) {
  var newDate = new Date(date);
  var y = 1900 + newDate.getYear();
  var m = "0" + (newDate.getMonth() + 1);
  var d = "0" + newDate.getDate();
  return y + "-" + m.substring(m.length - 2, m.length) + "-" + d.substring(d.length - 2, d.length);
}


//判断一个值是object
export function isObject(value) {
  const type = typeof value
  return value != null && (type == 'object' || type == 'function')
}

//判断登录token
export function getLoginStatus(http) {
  let arr = []
  let urlList = window.location.pathname.split("/").filter(d => d)
  const array = ['personal']
  if (http == 'post') {
    arr = urlList.filter(obj => obj == 'personal' || obj == 'serviceProvider' || obj == 'preferentialProductsDetail' || obj == 'applicationProcess' || obj == 'main' || obj == 'customService')
  } else if (http == 'get') {
    return true;
  } else {
    // arr = urlList.filter(obj => obj == 'personal' || obj == 'serviceProvider'|| obj == 'preferentialProductsDetail' )
    arr = urlList.filter(obj => obj == 'personal' || obj == 'serviceProvider' || obj == 'applicationProcess' || obj == 'main' || obj == 'customService')
  }

  // console.log('***************', arr)
  if (arr.length > 0) {
    return true
  } else {
    return false
  }
}

/**
 * 获取url参数值
 * @param {*} name 参数名称
 * @param {*} str  字符串 如：this.props.location.search
 * @returns  参数值
 */
export function getUrlParam(name, str) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = str.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]); return null;
}

/**
 * UUID生成
 * @returns 生成UUID
 */
export function createUUID() {
  let random4 = () => { return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1); }

  return (random4() + random4() + random4() + random4() + random4() + random4());
};

//验证是否登录
export function getStatus(){
  let userInfo =getCurrentUser()
  // console.log('getCurrentUser',userInfo);
  // let flag = false
  // if(!userInfo){
  //   return false
  // }
  return new Promise((resolve)=>{
    Http.postFrom(Request.getApplyStatus(),{id:userInfo?.user_id}, (obj) => {
      console.log('obj',obj);
      
      if (obj.code == 200) {
        // setJobTypeList(obj.data)
        // backReturn(obj.data)
        resolve(obj.data)
        // return true
        
      } else {
        message.error(obj.msg || obj.message || "请求失败，请重试");
  
        return false
      } 
  }
  )
  })

}
